<script setup>
import { storeToRefs } from 'pinia'
import Illustration from 'assets/illustrations/illu_megaphone.svg?url'
import { useMessageStore } from '~/stores/messages'

const props = defineProps({
    appDownloadContentConfig: {
        type: Object,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                title: value => value?.title === undefined || typeof value?.title === 'string',
                description: value => value?.description === undefined || typeof value?.description === 'string'
            }

            return Object.entries(validations).every(([_, validation]) => validation(rawValue))
        }
    }
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Markdown
const { $md } = useNuxtApp()
const appDownloadContentDescription = computed(() => $md.render(props.appDownloadContentConfig?.description || ''))

const appButtonsConfig = computed(() => {
    return {
        iosLink: staticKeys.value?.account_gettheapp_ios_link_content,
        androidLink: staticKeys.value?.account_gettheapp_android_link_content
    }
})
</script>

<template>
    <div class="app-download-content">
        <h2>{{ appDownloadContentConfig.title }}</h2>

        <img
            :src="Illustration"
            :alt="staticKeys?.account_gettheapp_headline"
            class="app-download-content-illustration"
            width="150"
            height="97"
        >

        <div v-html="appDownloadContentDescription" />

        <AppDownloadButtonBar class="app-download-content-button-bar" :app-download-button-bar-config="appButtonsConfig" />
    </div>
</template>

<style lang="scss">
.app-download-content {
  background: $app-download-content-bg;
  text-align: center;
  padding: 24px;
  border-radius: 24px;

  @include bp(medium1) {
    padding: 30px 30px 40px;
    margin: 0;
    border-radius: 0;
  }

  h2 {
    font-family: $font-headline;
    font-size: px2rem(32);
    line-height: px2rem(38);
    letter-spacing: px2rem(-1.5);
    font-style: italic;
    font-weight: 500;
    margin: 0 0 12px;
    padding: 0;

    @include bp(medium1) {
      margin: 0;
      padding: 0;
    }
  }

  p {
    @include body2-medium;

    margin: 0 auto 20px;
    max-width: 300px;
  }
}

.app-download-content-illustration {
  width: 150px;
  display: none;

  @include bp(medium1) {
    display: block;
    margin: 0 auto px2rem(10);
  }
}

.app-download-content-button-bar {
    display: flex;
    align-items: center;
    justify-content: center;

    a {
        display: block;
        line-height: 0;

        img {
            width: 140px;
            height: auto;
        }
    }
}
</style>
